import { ArticleHeading2, ArticleParagraph1, TDeviceType } from '@cian/ui-kit';
import * as style from './Welcome.css';
import classnames from 'classnames';
import { Switcher } from '../Switcher';
import { TWelcomeProps } from 'shared/types/welcome';

interface IWelcomeProps extends TWelcomeProps {
  device: TDeviceType;
}

export const Welcome: React.FC<IWelcomeProps> = ({ device, itemId, onActiveItemId }) => {
  const isPhone = device === 'phone';

  const SubTitle = isPhone ? ArticleParagraph1 : ArticleHeading2;

  return (
    <div
      className={classnames(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        isPhone && style['container-phone'],
      )}
    >
      <div className={style['wrapper']}>
        <div className={style['text-block']}>
          <h1 className={style['title']}>Как эффективно размещаться на Циан</h1>
          <SubTitle fontWeight="400" color="white_100" textAlign="center">
            Мы расскажем, как сделать привлекательное объявление и&nbsp;найти реального покупателя
          </SubTitle>
        </div>
        <Switcher itemId={itemId} onActiveItemId={onActiveItemId} />
      </div>
    </div>
  );
};
